module.exports = __webpack_public_path__ + "img/logo.fe59979e.svg";